import { authService } from "../services";
import { GLOBAL_STATUS } from "./global-enums";
import { customToast } from "../shared";
import { getItemFromStorage } from "./storage";
import {
  toastTypes,
  hubConstants,
  viewPathConstants,
  serverResponseConstants,
} from "../constants";

//Destructing constants
const {
  NETWORK_ERROR,
  SERVER_ISSUE,
  UNAUTHORIZE_ACCESS,
  SOMETHING_WENT_WRONG,
  UNAUTHORIZED_REDIRECT_DELAY_MS,
} = serverResponseConstants;

const { LOGIN } = viewPathConstants;

//Retrieves all error messages from an object of errors.
function allErrorMessages(errors) {
  let errorMessages = [];
  // eslint-disable-next-line
  Object.keys(errors).forEach((key) => {
    errorMessages.push(errors[key]);
  });
  return errorMessages;
}

const handleUnauthorizedAccess = () => {
  setTimeout(() => {
    if (
      getItemFromStorage(hubConstants.FROM_HUB_KEY) ===
      hubConstants.FROM_SURVEY_VALUE
    ) {
      authService.logout().then(() => window.location.assign(LOGIN));
    }
  }, UNAUTHORIZED_REDIRECT_DELAY_MS);
};

const handleUnauthorizedAccessWithResponseStatus = (responseStatus) => {
  if (
    responseStatus === GLOBAL_STATUS.UNAUTHORIZED ||
    responseStatus === GLOBAL_STATUS.FORBIDDEN
  ) {
    customToast(UNAUTHORIZE_ACCESS, toastTypes.ERROR);
    handleUnauthorizedAccess();
  }
};

const handleResponseDataError = (httpResponse) => {
  if (httpResponse.data.errors) {
    return allErrorMessages(httpResponse.data.errors);
  } else {
    return [];
  }
};

//Function to handle http response from server and perform action accordingly
function handleHTTPResponses(httpResponse) {
  let errorMessages = [];
  if (!httpResponse) {
    errorMessages.push(SERVER_ISSUE);
    return Promise.reject(errorMessages);
  }

  const { message } = httpResponse.data;
  const responseStatus = httpResponse.status;
  if (message === NETWORK_ERROR) {
    errorMessages.push(SERVER_ISSUE);
    return Promise.reject(errorMessages);
  }
  if (message === UNAUTHORIZE_ACCESS) {
    handleUnauthorizedAccess();
  }
  if (responseStatus !== GLOBAL_STATUS.SUCCESS) {
    handleUnauthorizedAccessWithResponseStatus(responseStatus);
    errorMessages = handleResponseDataError(httpResponse);
    errorMessages.unshift(message);
    return Promise.reject(errorMessages);
  }
  return httpResponse;
}

//Function to handle action by server response text
function handleResponseByStatus(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (
      response.status === GLOBAL_STATUS.UNAUTHORIZED &&
      getItemFromStorage(hubConstants.FROM_HUB_KEY) ===
        hubConstants.FROM_SURVEY_VALUE
    ) {
      // auto logout if 401 response returned from api
      authService.logout().then(window.location.assign(LOGIN));
    }

    const error = data?.message || response.statusText;
    return Promise.reject(error);
  });
}

//Handles server response
function handleServerResponse(response) {
  const { status, message, errors = [], data } = response;
  if (status === GLOBAL_STATUS.SUCCESS) {
    return data.payload;
  }
  const Msg = () => (
    <div>
      <h4 className="m-0">{message || SOMETHING_WENT_WRONG}</h4>
      {Object.keys(errors).map((key) => (
        <div key={key}>{errors[key]}</div>
      ))}
    </div>
  );
  return Promise.reject(Msg);
}
const responseHandler = {
  handleHTTPResponses,
  handleResponseByStatus,
  handleServerResponse,
};

export default responseHandler;
